import createEvent from '@/scripts/utils/create-event';

export const startLoading = () => {
  console.log('Loading'); // eslint-disable-line no-console
};

export const chunkLoaded = () => {
  $(document.documentElement).data('chunk-loaded', true);
  document.documentElement.dispatchEvent(createEvent('chunkLoaded'));
};

export const removePreloader = () => {
  document.documentElement.classList.remove('has-preloader');
  document.documentElement.dispatchEvent(createEvent('preloaderEnd'));
  console.log('Loading finished. Enjoy!'); // eslint-disable-line no-console
  return true;
};



// WEBPACK FOOTER //
// ./scripts/elements/preloader.js